export const DRAFT_COOKIE_OPTIONS = {
    httpOnly: false,
    secure: true,
    sameSite: 'none', // None is required for cookies in the Iframe of Storyblok's Visual Editor
    path: '/',

    /**
     * We use partitioned cookies here to be able to keep the draft mode disabled when
     * opening the page directly without having it overridden by the automatic draft
     * mode inside the Iframe of Storyblok's Visual Editor. This way the status of the
     * draft mode can be different between the Iframe and opening the page directly.
     */
    partitioned: true
} as const;

/** Allows confirmation gate acceptance to persist separately in the Visual Editor iframe and direct visits. */
export const CONFIRMATION_GATE_COOKIE_OPTIONS = {
    httpOnly: false,
    secure: true,
    sameSite: 'none',
    path: '/',
    partitioned: true,
    maxAge: 60 * 60 * 24 * 365
} as const;

export const AUTH_COOKIE_OPTIONS_LAX = {
    secure: true,
    sameSite: 'lax',
    path: '/'
} as const;

/**
 * Partitioned auth cookies are required for authenticated requests inside the
 * Storyblok Visual Editor iframe. Cookies set in a popup use a different CHIPS
 * partition and are bridged back via `/api/auth/iframe-complete`.
 */
export const AUTH_COOKIE_OPTIONS_PARTITIONED = {
    secure: true,
    sameSite: 'none',
    path: '/',
    partitioned: true
} as const;

export const AUTH_CLIENT_COOKIE_OPTIONS_LAX = {
    httpOnly: false,
    secure: true,
    sameSite: 'lax',
    path: '/'
} as const;

export const AUTH_CLIENT_COOKIE_OPTIONS_PARTITIONED = {
    httpOnly: false,
    secure: true,
    sameSite: 'none',
    path: '/',
    partitioned: true
} as const;
